function renderVersionSnapshotHelpersRowsTemplate({
  fieldName,
  relIdCol,
  junctionVar,
  entityIdCol
}: {
  fieldName: string
  relIdCol: string
  junctionVar: string
  entityIdCol: string
}): string {
  return `  const ${fieldName}Rows = await client
    .select({ ${relIdCol}: ${junctionVar}.${relIdCol} })
    .from(${junctionVar})
    .where(eq(${junctionVar}.${entityIdCol}, id))
  snapshot.${fieldName} = ${fieldName}Rows.map((row) => row.${relIdCol})`
}

function renderVersionSnapshotHelpersSourceTemplate({
  ctxSingular,
  loadM2MStatements
}: {
  ctxSingular: string
  loadM2MStatements: string
}): string {
  return `
export async function build${ctxSingular}VersionSnapshotWithRelationships(
  row: Partial<${ctxSingular}> | Record<string, unknown>,
  client: VersionSnapshotClient = db
): Promise<Record<string, unknown>> {
  const source = row as Record<string, unknown>
  const snapshot = build${ctxSingular}VersionSnapshot(source)
  const id = typeof source.id === 'string' ? source.id : null

  if (!id) {
    for (const key of VERSION_M2M_KEYS) {
      snapshot[key] = Array.isArray(snapshot[key]) ? snapshot[key] : []
    }
    return snapshot
  }

${loadM2MStatements}

  return snapshot
}
`
}

function renderVersionSnapshotHelpersGeneratedFunctionTemplate({
  snapshotClientType,
  snapshotKeys,
  restoreKeys,
  m2mKeys,
  ctxSingular,
  relationshipSnapshotHelper
}: {
  snapshotClientType: string
  snapshotKeys: string
  restoreKeys: string
  m2mKeys: string
  ctxSingular: string
  relationshipSnapshotHelper: string
}): string {
  return `${snapshotClientType}const VERSION_SNAPSHOT_KEYS = [${snapshotKeys}] as const
const VERSION_RESTORE_KEYS = [${restoreKeys}] as const
const VERSION_M2M_KEYS = [${m2mKeys}] as const

export function build${ctxSingular}VersionSnapshot(row: Partial<${ctxSingular}> | Record<string, unknown>): Record<string, unknown> {
  const source = row as unknown as Record<string, unknown>
  const snapshot: Record<string, unknown> = {}

  for (const key of VERSION_SNAPSHOT_KEYS) {
    if (key in source) {
      snapshot[key] = source[key]
    }
  }

  for (const key of VERSION_M2M_KEYS) {
    snapshot[key] = Array.isArray(snapshot[key]) ? snapshot[key] : []
  }

  return snapshot
}
${relationshipSnapshotHelper}

export function build${ctxSingular}RestoreData(data: Record<string, unknown>): Record<string, unknown> {
  const restoreData: Record<string, unknown> = {}

  for (const key of VERSION_RESTORE_KEYS) {
    if (key in data) {
      restoreData[key] = data[key]
    }
  }

  return restoreData
}

export function has${ctxSingular}VersionChanges(
  previous: Record<string, unknown>,
  next: Record<string, unknown>
): boolean {
  return JSON.stringify(previous) !== JSON.stringify(next)
}`
}

export function renderVersionSnapshotHelpersRenderer(
  request:
    | {
        kind: 'renderVersionSnapshotHelpersRowsTemplate'
        props: {
          fieldName: string
          relIdCol: string
          junctionVar: string
          entityIdCol: string
        }
      }
    | {
        kind: 'renderVersionSnapshotHelpersSourceTemplate'
        props: {
          ctxSingular: string
          loadM2MStatements: string
        }
      }
    | {
        kind: 'renderVersionSnapshotHelpersGeneratedFunctionTemplate'
        props: {
          snapshotClientType: string
          snapshotKeys: string
          restoreKeys: string
          m2mKeys: string
          ctxSingular: string
          relationshipSnapshotHelper: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderVersionSnapshotHelpersRowsTemplate':
      return renderVersionSnapshotHelpersRowsTemplate(request.props)
    case 'renderVersionSnapshotHelpersSourceTemplate':
      return renderVersionSnapshotHelpersSourceTemplate(request.props)
    case 'renderVersionSnapshotHelpersGeneratedFunctionTemplate':
      return renderVersionSnapshotHelpersGeneratedFunctionTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
